export default "__VITE_ASSET__DqNiN3_A__"